import { Badge } from '@synoptic/ui-kit/badge/badge.tsx';
import { StarIcon } from '@synoptic/ui-kit/icons/react/star.tsx';
import { featuredBadge } from '@/components/stream-list/stream-card/stream-card.css.ts';

export const FeaturedBadge = () => {
  return (
    <Badge color={'auxLightBlue'} className={featuredBadge}>
      <StarIcon width={16} height={16} />
      <span>Featured</span>
    </Badge>
  );
};
